import LoggedInUser from './LoggedInUser';
import Helpers from './Helpers';

export function mappedFunnelData(json, dataKey) {
  const data = json.data[json.meta.dates[0]].steps;
  const maxVal = data[0].count;
  return data.map(datum => {
    const returnValue = { name: datum.step_label };
    returnValue[dataKey] = datum.count;
    return returnValue;
  });
}

export function getFunnel(funnel_id, from_date, doRecent = false)
{
    const headers = new Headers();
    headers.append('Authorization', 'Basic ' + btoa(process.env.REACT_APP_MIXPANEL_SECRET+ ":" ));
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    const fromDate = doRecent === false ? `&from_date=${from_date}` : "";
    return fetch(
      `https://mixpanel.com/api/2.0/funnels?funnel_id=${funnel_id}&unit=month${fromDate}&unit=1`,
      {
        method: 'GET',
        headers,
    }).then((response) => response.json())
}

export function conversionMetric(dateRanges) {
  return fetch(Helpers.endpoint("/admin_conversion_metric"), {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      auth_token: LoggedInUser.getInfo().auth_token,
      date_ranges: dateRanges,
    })
  }).then((response) => response.json())

}


export function disintermediationMetric(dateRanges) {
  return fetch(Helpers.endpoint("/admin_disintermediation_metric"), {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      auth_token: LoggedInUser.getInfo().auth_token,
      date_ranges: dateRanges,
    })
  }).then((response) => response.json())

}


export function newClients(dateRanges) {
  return fetch(Helpers.endpoint("/admin_new_clients"), {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      auth_token: LoggedInUser.getInfo().auth_token,
      date_ranges: dateRanges,
    })
  }).then((response) => response.json())

}

